import { useState } from "react";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import DeleteCartConfirmationModal from "~/domains/cart/components/DeleteCartConfirmationModal";

import { type EmailOrderQuoteData } from "../types";

interface EmailOrderQuotePopupConfirmationProps {
  onOk: (data: EmailOrderQuoteData) => void;
  onCancel: (data: EmailOrderQuoteData) => void;
}

export const useEmailOrderQuoteConfirmation = ({ onOk, onCancel }: EmailOrderQuotePopupConfirmationProps) => {
  const { setTrue: openPopup, setFalse: closePopup, val: isModalOpen } = useBooleanState(false);

  const emptyData: EmailOrderQuoteData = {
    recipientEmail: "",
    orderAcknowledgement: [],
    quoteAcknowledgement: [],
  };
  const [emailData, setEmailData] = useState<EmailOrderQuoteData>(emptyData);

  const open = (emailOrderQuoteData?: EmailOrderQuoteData) => {
    if (emailOrderQuoteData) {
      setEmailData(emailOrderQuoteData);
    } else {
      setEmailData(emptyData);
    }
    openPopup();
  };

  const close = () => {
    setEmailData(emptyData);
    closePopup();
  };

  const modal = isModalOpen && (
    <DeleteCartConfirmationModal
      onCancel={() => {
        close();
        onCancel(emailData);
      }}
      onOk={() => {
        close();
        onOk(emailData);
      }}
      messageKey={"page.orderQuoteSettings.notification.delete"}
    />
  );

  return { modal, open, close, visible: isModalOpen } as const;
};
